export class WindowHelper {
    static getTheWindowWidth() {
        return Math.max(
            document.body.scrollWidth,
            document.documentElement.scrollWidth,
            document.body.offsetWidth,
            document.documentElement.offsetWidth,
            document.documentElement.clientWidth,
        );
    }
    static resolutionIsTabletOrHigher() {
        return this.getTheWindowWidth() > 768;
    }
    static resolutionIsDesktopOrHigher() {
        return this.getTheWindowWidth() > 1024;
    }
    static isElementThere(theQuerySelector) {
        return !!document.querySelector(theQuerySelector);
    }
    /* static isTouchDevice() {
        return ('ontouchstart' in window) || (window.DocumentTouch && document instanceof DocumentTouch);//'ontouchstart' in document.documentElement;//
    } */
    static isTouchDevice() {
        try {
            document.createEvent('TouchEvent');
            return true;
        } catch (exc) {
            return false;
        }
    }

    static getCurrentRootURL() {
        const root_url = `${window.location.protocol}//${window.location.host}/`;
        console.log('root_url', root_url);
        return root_url.indexOf('11.0.0.2') > -1 ? `${root_url}/bauzeit-architekten/` : root_url;
    }
}
